//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import rem from "../../common/rem";
let console1 = 0;

export default {
  name: "tutorial",
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        autoplay: true,
        loop: true,
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 0,
      },
      kechengList: [],
      swiperList: [],
      audioList: [],
      date: {
        day: 0,
        mouth: 0,
        days: 0,
      },
      indexPic: "",
    };
  },
  methods: {
    getKechengList() {
      this.axios.post("/xcx/Order/courseList").then((res) => {
        this.kechengList = res.data.data.list;
        this.swiperList = res.data.data.slide;
      });
    },
    getAudioList() {
      this.axios.post("/xcx/Order/audio").then((res) => {
        this.swiperList = res.data.data.slide;
        this.audioList = res.data.data.list;
      });
    },
    day2chn(day) {
      var days = ["天", "一", "二", "三", "四", "五", "六"];
      return days[day];
    },
    month2chn(month) {
      var months = [
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
        "十",
        "十一",
        "十二",
      ];
      return months[month];
    },

    getVideo() {
      this.axios.post("/xcx/Order/indexSlide").then((res) => {
        this.indexPic = res.data.data.pic;
      });
    },
    opendebug() {
      console1++;
      if (console1 == 5) {
        let script = document.createElement("script");
        script.src = "//cdn.jsdelivr.net/npm/eruda";
        document.body.append(script);
        script.onload = () => {
          let script2 = document.createElement("script");
          script2.text = "eruda.init();";
          document.body.append(script2);
        };
        window.debug = true;
      }
    },
    goStudy(id) {
      if (!this.$store.state.user_info.phone) {
        this.$router.push({ name: "register" });
      } else {
        this.$router.push({ name: "detail", params: { id } });
      }
    },
  },
  mounted() {
    rem();
    if (this.$route.params.showalert) {
      this.$vux.alert.show({
        title: "提示",
        content: "您还没有解锁该课程",
        buttonText: "立即购课",
      });
    }
  },
  created() {
    rem();
    this.getVideo();
    var date = new Date();
    var day = date.getDay();
    var month = date.getMonth();
    var days = date.getDate();
    this.date.day = this.day2chn(day);
    this.date.month = this.month2chn(month);
    this.date.days = days;
    if (this.$route.query.type == "audio") {
      this.getAudioList();
    } else {
      this.getKechengList();
    }

    var token = this.$cookies.get("token");
    if (token && token != "") {
      this.axios.post("/xcx/Order/testStatus").then((res) => {
        if (res.data.data.code == 1) {
        } else {
          // this.$router.replace({name:'test'});
        }
      });
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/tutorial/tutorial.vue